<template>
  <div class="wa-audio-custom-player" :class="{ 'is-saliente': esSaliente, 'is-playing': reproduciendo }">
    <!-- Hidden native audio element -->
    <audio
      ref="audioRef"
      :src="src"
      preload="metadata"
      @loadedmetadata="onLoadedMetadata"
      @timeupdate="onTimeUpdate"
      @ended="onEnded"
      @pause="reproduciendo = false"
      @play="reproduciendo = true"
    ></audio>

    <!-- Play/Pause Button with Avatar/Mic badge -->
    <div class="wa-audio-play-wrapper">
      <button
        type="button"
        class="wa-audio-btn-play"
        :class="{ 'playing': reproduciendo }"
        @click.stop="togglePlay"
        :title="reproduciendo ? 'Pausar' : 'Reproducir'"
      >
        <i :class="reproduciendo ? 'mdi mdi-pause' : 'mdi mdi-play'"></i>
      </button>

      <!-- Small voice icon badge -->
      <span class="wa-audio-mic-badge" :title="esSaliente ? 'Nota de voz enviada' : 'Nota de voz recibida'">
        <i class="mdi mdi-microphone font-size-12"></i>
      </span>
    </div>

    <!-- Waveform / Progress slider and metadata -->
    <div class="wa-audio-track-col">
      <!-- Custom range slider track -->
      <div class="wa-audio-seeker-wrapper">
        <input
          type="range"
          class="wa-audio-range"
          min="0"
          :max="duracion || 100"
          step="0.1"
          :value="tiempoActual"
          :style="{ '--progress': progresoPorcentaje + '%' }"
          @input="onSeek"
          @click.stop
        />
        <!-- Simulated WhatsApp waveform dots/bars behind track -->
        <div class="wa-audio-waveform-bars">
          <span
            v-for="n in 26"
            :key="n"
            class="wa-waveform-bar"
            :class="{ 'is-active': (n / 26) * 100 <= progresoPorcentaje }"
            :style="{ height: (6 + ((n * 7) % 14)) + 'px' }"
          ></span>
        </div>
      </div>

      <!-- Duration and Speed Controls -->
      <div class="wa-audio-meta-row">
        <span class="wa-audio-time">{{ tiempoFormateado }}</span>
        <button
          v-if="reproduciendo || tiempoActual > 0"
          type="button"
          class="wa-audio-speed-btn"
          @click.stop="cambiarVelocidad"
          title="Velocidad de reproducción"
        >
          {{ velocidad }}x
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CmpAudioPlayer",
  props: {
    src: {
      type: String,
      required: true
    },
    esSaliente: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      reproduciendo: false,
      tiempoActual: 0,
      duracion: 0,
      velocidad: 1,
      cargando: false
    };
  },
  computed: {
    progresoPorcentaje() {
      if (!this.duracion || this.duracion === 0) return 0;
      return Math.min(100, Math.max(0, (this.tiempoActual / this.duracion) * 100));
    },
    tiempoFormateado() {
      // Si está reproduciendo o se ha movido el seeker, mostramos tiempo actual; si no, la duración total
      const segs = this.reproduciendo || this.tiempoActual > 0 ? this.tiempoActual : (this.duracion || 0);
      return this.formatoTiempo(segs);
    }
  },
  watch: {
    src() {
      this.reiniciar();
    }
  },
  methods: {
    formatoTiempo(segundosTotales) {
      if (isNaN(segundosTotales) || segundosTotales === Infinity || segundosTotales < 0) return "0:00";
      const mins = Math.floor(segundosTotales / 60);
      const segs = Math.floor(segundosTotales % 60);
      return `${mins}:${segs < 10 ? "0" : ""}${segs}`;
    },
    togglePlay() {
      const audio = this.$refs.audioRef;
      if (!audio) return;

      if (this.reproduciendo) {
        audio.pause();
        this.reproduciendo = false;
      } else {
        // Pausar cualquier otro audio que esté sonando en la página
        document.querySelectorAll("audio").forEach((el) => {
          if (el !== audio && !el.paused) el.pause();
        });

        audio.play().then(() => {
          this.reproduciendo = true;
        }).catch(() => {
          this.reproduciendo = false;
        });
      }
    },
    onLoadedMetadata() {
      const audio = this.$refs.audioRef;
      if (audio && !isNaN(audio.duration)) {
        this.duracion = audio.duration;
      }
    },
    onTimeUpdate() {
      const audio = this.$refs.audioRef;
      if (audio) {
        this.tiempoActual = audio.currentTime;
        if (!this.duracion && !isNaN(audio.duration)) {
          this.duracion = audio.duration;
        }
      }
    },
    onEnded() {
      this.reproduciendo = false;
      this.tiempoActual = 0;
      const audio = this.$refs.audioRef;
      if (audio) {
        audio.currentTime = 0;
      }
    },
    onSeek(event) {
      const audio = this.$refs.audioRef;
      if (!audio) return;
      const valor = parseFloat(event.target.value);
      audio.currentTime = valor;
      this.tiempoActual = valor;
    },
    cambiarVelocidad() {
      const audio = this.$refs.audioRef;
      if (!audio) return;
      if (this.velocidad === 1) this.velocidad = 1.5;
      else if (this.velocidad === 1.5) this.velocidad = 2;
      else this.velocidad = 1;
      audio.playbackRate = this.velocidad;
    },
    reiniciar() {
      this.reproduciendo = false;
      this.tiempoActual = 0;
      this.duracion = 0;
      this.velocidad = 1;
      const audio = this.$refs.audioRef;
      if (audio) {
        audio.playbackRate = 1;
      }
    }
  }
};
</script>
